import { Sparkles, Volume2, VolumeX, X } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Interview header with branding, audio toggle, and end interview button
 */
const InterviewHeader = ({
  speechEnabled,
  onSpeechToggle,
  onEndInterview,
  isToggleDisabled = false,
}) => {
  return (
    <div className="flex-none bg-blue-50 px-4 py-3 border-b border-blue-100 rounded-t-xl">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="/writingcar.png"
            alt="InternHub Cat"
            className="w-8 h-8 rounded-[20%] border-2 border-white shadow-sm"
          />
          <div>
            <h3 className="font-semibold text-gray-900">Behavioral Interview Session</h3>
            <p className="text-sm text-gray-600 flex items-center gap-1">
              with InternHub Cat AI
              <Sparkles className="h-3 w-3 text-blue-500" />
            </p>
          </div>
        </div>

        <div className="flex gap-2">
          {/* End Interview button */}
          <button
            onClick={onEndInterview}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm bg-red-100 text-red-700 hover:bg-red-200 transition-colors"
            title="End Interview"
          >
            <X className="h-4 w-4" />
            <span>End Interview Now</span>
          </button>

          {/* Speech toggle switch */}
          <button
            onClick={onSpeechToggle}
            disabled={isToggleDisabled}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-colors ${
              isToggleDisabled
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed opacity-60'
                : speechEnabled
                  ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            title={isToggleDisabled ? 'Cannot switch audio mode while responding' : undefined}
          >
            {speechEnabled ? (
              <>
                <Volume2 className="h-4 w-4" />
                <span>Audio On</span>
              </>
            ) : (
              <>
                <VolumeX className="h-4 w-4" />
                <span>Audio Off</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

InterviewHeader.propTypes = {
  speechEnabled: PropTypes.bool.isRequired,
  onSpeechToggle: PropTypes.func.isRequired,
  onEndInterview: PropTypes.func.isRequired,
  isToggleDisabled: PropTypes.bool,
};

export default InterviewHeader;
